import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'hds-core';
import 'hds-core/lib/components/text-input/text-input.css';
import 'hds-core/lib/components/button/button.css';
import getMessage from '../../utils/getMessage';
import api from '../../api';
import PleaseLoginToJoinHearing from '../../components/admin/PleaseLoginToJoinHearing';
import { getUser } from '../../store/selectors/user';
import PropTypes from 'prop-types';

const JoinHearingFacilitator = ({match, history, user}) => {
  const [error, setError] = useState(null)
  
  const onSubmit = async e => {
    e.preventDefault();
    try {
      const joinToken = match.params.joinToken;
      const hearingSlug = match.params.hearingSlug;
      const url = '/v1/hearing/' + hearingSlug + '/join_facilitator/';
      api.post({}, url, {token: joinToken}).then((response) => {
        if (response.status === 200) {
          history.push('/' + hearingSlug);
        }
        else {
          const errorMessage = getMessage('registrationFailed');
          setError(errorMessage);
        }
      });
    } catch (e) {
      throw new Error("Couldn't log in.");
    }
  };

  return (
    <div>
    {user ?
      <form className="hds-form hds-form--login" onSubmit={onSubmit}>
        <h1>{getMessage('joinHearingHeaderFacilitator')}</h1>
        <div className="hds-card">
          {error &&
            <div className="alert alert-danger">
              {error}
            </div>
          }
          <p>{getMessage('joinHearingBody')}</p>
          <button type="submit" className="digi-button">
            {getMessage('join')}
          </button>
        </div>
      </form>
    :
      <div class="container">
        <PleaseLoginToJoinHearing
          login={() => history.push({pathname: '/auth/login', search: '?next=' + history.location.pathname})}
          register={() => history.push({pathname: '/auth/registration', search: '?next=' + history.location.pathname})}
        />
      </div>
    }
    </div>
  );
}

JoinHearingFacilitator.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: getUser(state),
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(JoinHearingFacilitator);
